import React, { isValidElement, ReactNode } from "react";

export const cloneNode = ({
    node,
    index,
    dataObj,
    keepFunctional,
    additionalProps
}: {
    node: React.ReactElement;
    index: number;
    dataObj: any;
    keepFunctional?: boolean;
    additionalProps?: Record<string, any>;
}): React.ReactNode => {
    if (!node?.props?.node) {
        return null;
    }

    const newClassName =
        !keepFunctional && node.props.node?.attr?.className
            ? node.props.node?.attr?.className
                  .split(" ")
                  .filter((className: string) => {
                      return className !== "builder-selected" && className !== "builder-hover";
                  })
                  .join(" ")
            : null;

    const clone = React.cloneElement(node, {
        key: node.props.node.id + "-" + index,
        id: node.props.node.id + "-" + index,
        ...(keepFunctional
            ? {}
            : {
                  node: {
                      ...node.props.node,
                      id: node.props.node.id + "-" + index,
                      attr: {
                          ...node.props.node.attr,
                          ...(newClassName !== null && { className: newClassName }),
                          ...(!keepFunctional && {
                              style: {
                                  ...node.props.node.attr?.style,
                                  opacity: 0.7
                              }
                          })
                      }
                  }
              }),
        ...(keepFunctional
            ? {}
            : {
                  builderProps: { containerDisabled: true }
              }),
        ...(node.props.children && Array.isArray(node.props.children) && node.props.children.length > 0
            ? {
                  children: node.props.children
                      .map((child: React.ReactElement) =>
                          cloneNode({
                              node: {
                                  ...child,
                                  props: {
                                      ...child.props,
                                      node: {
                                          ...child.props.node,
                                          previewChildIndex: index === 0 ? child.props.node.previewChildIndex : undefined
                                      }
                                  }
                              }, // on builder, clones should not be affected by previewChildIndex
                              index,
                              dataObj,
                              keepFunctional: keepFunctional
                          })
                      )
                      .flat()
              }
            : {}),
        dataObject: dataObj,
        ...(additionalProps || {})
    });

    return clone;
};

export const findInChildren = (children: ReactNode[], name: string) => {
    try {
        const foundIndex = children.findIndex(child => {
            return isValidElement(child) && child.props?.node?.name === name;
        });

        if (foundIndex !== -1) {
            return foundIndex;
        } else {
            return -1;
        }
    } catch (e) {
        console.log(e);
        return -1;
    }
};
